<template>
	<div class="main">
		<div class="naverwebtoon">
			<img class="close b-close" src="../assets/image/close.png" alt="">
			<a href=""><img src="../assets/image/naverwebtoon_bigbanner.png" alt=""></a>
		</div>
		<div class="box">
			<Header ref="header"></Header>
			<GameBanner :src="gameData.topBgImage" :variant="gameData.extraFields.bannerType"
				:drawProductId="gameData.extraFields.bannerDrawProductId" />
			<div class="item_Options">
				<div class="content">
					<UserInfo ref="userInfo"></UserInfo>
					<div class="position">
						<div class="position-item">
							<div class="points-balance-container">
								<img class="points-icon" src="/static/image/points_new.png">
								<p class="points-text">
									{{ $t('pointsBalanceText') }}:
									<span class="points-amount">{{ balance }}</span>
								</p>
								<button class="balance-refresh-btn"
									:class="{ 'balance-refresh-btn--spinning': isRefreshing }"
									:disabled="isRefreshing || !hasLogin" @click="refreshBalance">&#x21bb;</button>
							</div>
						</div>

						<!-- 积分兑换商品 -->
						<ul class="points_box">
							<li class="pc-item" v-for="(item, index) in pointsList" :key="item.id">
								<!-- 顶部：标签 + 周期次数 -->
								<div class="pc-header">
									<span class="pc-tag" :class="'pc-tag--' + item.tagType" v-if="item.tagType">{{
										$t('points_tag_' + item.tagType) }}</span>
									<span class="pc-period theme_color" v-if="item.period && item.period != 'none'">
										{{ $t('points_period_' + item.period) }} {{ item.used }}/{{ item.limit }}
									</span>
								</div>

								<!-- 商品图 -->
								<div class="pc-img-wrap">
									<img class="pc-img" :src="item.icon" alt="">
								</div>

								<!-- 奖励名称 -->
								<div class="pc-name">
									<p v-for="(reward, ri) in item.rewards" :key="ri">{{ reward }}</p>
								</div>

								<!-- 兑换按钮 -->
								<button :id="'btn_' + item.id" class="pc-btn bg_color"
									:class="{ 'pc-btn--disabled': isExhausted(item) }" :disabled="isExhausted(item)"
									@click="exchangeRewards(item)">
									<span :id="'btn_span_' + item.id" class="pc-btn-inner">
										{{ item.cost }}
										<img src="/static/image/points_new.png" class="pc-coin">
									</span>
								</button>
							</li>
						</ul>

						<p class="h3">{{ $t('recharge_instructions_text') }}</p>
						<p class="instructions" v-html="gameData.describe"></p>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>
		<TipsWindow ref="tips"></TipsWindow>
		<RewardPopup ref="rewardPopup"></RewardPopup>
	</div>
</template>

<script>
import Header from '../components/header.vue'
import Footer from '../components/footer.vue'
import UserInfo from '../components/userInfo.vue'
import RewardPopup from '../components/RewardPopup.vue'
import TipsWindow from '../components/tipsWindow.vue'
import GameBanner from '../components/GameBanner.vue'
import { isEmpty } from '../utils/index.js'

export default {
	name: 'points',

	components: {
		Header,
		Footer,
		UserInfo,
		RewardPopup,
		TipsWindow,
		GameBanner
	},

	data() {
		return {
			pointsList: [],
			balance: 0,
			gameData: this.$store.state.gameData,
			hasLogin: this.$session.hasLogin(),
			isRefreshing: false,
		}
	},

	mounted() {
		this.changeBackground(this.gameData.bottomBgImage);
		this.loadRewardsList();
		if (this.hasLogin) {
			this.loadPointsData();
		}
	},

	methods: {
		// 加载积分奖励列表
		async loadRewardsList() {
			const response = await this.$axios({
				method: 'get',
				url: '/web/api/points/rewards',
				params: {
					userId: this.$session.getUserId(),
					gameCode: this.$cache.getGameCode(),
				},
			});
			if (response.code === 1000) {
				this.pointsList = response.data || [];
			}
		},

		// 加载积分余额
		async loadPointsData() {
			const response = await this.$axios({
				method: 'get',
				url: '/web/api/points/initData',
				params: {
					userId: this.$session.getUserId(),
					gameCode: this.$cache.getGameCode(),
				},
			});
			if (response.code === 1000) {
				this.balance = response.data.balance;
			}
		},

		// 兑换奖励
		async exchangeRewards(item) {
			const role = this.$cache.getRoleInfo();
			if (isEmpty(role) || isEmpty(role.roleId)) {
				this.$refs.userInfo.openRoleChooseWindow();
				return;
			}

			if (item.cost > this.balance) {
				this.$refs.tips.show(this.$i18n.tc('insufficient_points_text'));
				return;
			}

			this.setButtonLoading(item.id, true);

			try {
				const response = await this.$axios({
					method: 'POST',
					url: '/web/api/points/exchange',
					data: {
						userId: this.$session.getUserId(),
						gameCode: this.$cache.getGameCode(),
						serverCode: role.serverCode,
						roleId: role.roleId,
						itemId: item.id,
					},
				});

				if (response.code === 1000) {
					this.balance = response.data;
					item.used = (item.used || 0) + 1;
					this.$refs.rewardPopup.show({
						image: item.icon,
						describe: (item.rewards || []).join(' / '),
					});
				} else if (response.code === 4003) {
					this.$refs.tips.show(this.$i18n.tc('points_limit_tips_text'));
				} else {
					this.$refs.tips.show(response.message);
				}
			} finally {
				this.setButtonLoading(item.id, false);
			}
		},

		// 手动刷新积分余额
		async refreshBalance() {
			this.isRefreshing = true;
			try {
				await this.loadPointsData();
			} finally {
				this.isRefreshing = false;
			}
		},

		// 设置兑换按钮加载状态
		setButtonLoading(itemId, loading) {
			const btnSpan = document.getElementById('btn_span_' + itemId);
			if (btnSpan) btnSpan.style.display = loading ? 'none' : 'block';
			this.$setLoading('btn_' + itemId, loading);
		},

		// 判断兑换次数是否已达上限
		isExhausted(item) {
			return (item.limit > 0 && item.used >= item.limit) || item.cost > this.balance;
		},

		changeBackground(newPath) {
			
		},
	},
}
</script>

<style>
/* ================================================================
   积分卡片（.pc-item）—— 完全独立于通用 ul li 样式
   高特异性选择器覆盖 .item_Options .position ul li
================================================================ */

.item_Options .position .points_box li.pc-item {
	/* 重置基础样式 */
	border: 0.03rem solid #EEEFF0 !important;
	padding-bottom: 0 !important;
	justify-content: flex-start !important;

	/* 卡片外观 */
	background: #fff !important;
	border-radius: 0.18rem !important;
	overflow: hidden;
	transition: transform 0.18s ease, border-color 0.12s ease;
}

.item_Options .position .points_box li.pc-item:hover {
	transform: translateY(-2px);
	border-color: rgba(0, 0, 0, 0.08) !important;
}

/* ---- 顶部标签行 ---- */
.pc-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.12rem 0.14rem 0;
	min-height: 0.42rem;
	box-sizing: border-box;
}

.pc-tag {
	display: inline-block;
	color: #fff;
	font-size: 0.14rem;
	font-weight: 700;
	padding: 0.04rem 0.16rem;
	border-radius: 1rem;
	white-space: nowrap;
	letter-spacing: 0.02em;
	line-height: 1.4;
	background: linear-gradient(135deg, #ff6b3d 0%, #e8302b 100%);
	/* 默认红色 */
}

.pc-tag--mustBuy {
	background: linear-gradient(135deg, #ff4d4d 0%, #cc0000 100%);
}

.pc-tag--selected {
	background: linear-gradient(135deg, #4d9fff 0%, #1565c0 100%);
}

.pc-tag--discount {
	background: linear-gradient(135deg, #ffaa33 0%, #e67700 100%);
}

.pc-tag--perk {
	background: linear-gradient(135deg, #4caf7d 0%, #1b7a45 100%);
}

.pc-period {
	font-size: 0.15rem;
	font-weight: 700;
	white-space: nowrap;
	margin-left: auto;
}

/* ---- 图片区域 ---- */
.pc-img-wrap {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0.14rem 0 0.08rem;
}

.pc-img {
	width: 1.1rem !important;
	height: 1.1rem !important;
	object-fit: contain;
	margin: 0 !important;
}

/* ---- 奖励名称 ---- */
.pc-name {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 0 0.12rem 0.12rem;
}

.pc-name p {
	margin: 0;
	font-size: 0.17rem !important;
	font-weight: 600;
	color: #333;
	text-align: center;
	line-height: 1.5;
}

/* ---- 兑换按钮 ---- */
.item_Options .position .points_box li.pc-item .pc-btn {
	/* 重置基础 button 样式 */
	align-self: stretch !important;
	margin: 0 0.14rem 0.14rem !important;
	width: calc(100% - 0.28rem) !important;
	height: 0.47rem !important;
	border-radius: 1rem !important;
	font-size: 0.2rem !important;
	font-weight: 700 !important;
	border: none !important;
	outline: none !important;
	color: #fff !important;
	cursor: pointer;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
}

.pc-btn-inner {
	display: flex;
	align-items: center;
	gap: 0.08rem;
	pointer-events: none;
}

.pc-coin {
	width: 0.22rem !important;
	height: 0.22rem !important;
	position: static !important;
	top: unset !important;
	vertical-align: middle;
}

/* ---- 禁用态 ---- */
.pc-btn--disabled {
	opacity: 0.42 !important;
	cursor: not-allowed !important;
	pointer-events: none;
}

/* ---- 积分余额刷新按钮 ---- */
.balance-refresh-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	margin-left: 0.12rem;
	width: 0.36rem;
	height: 0.36rem;
	border-radius: 0.08rem;
	border: 0.02rem solid var(--theme-color, #f90);
	background: transparent;
	color: var(--theme-color, #f90);
	font-size: 0.22rem;
	line-height: 1;
	cursor: pointer;
	transition: background 0.15s ease;
	flex-shrink: 0;
}

.balance-refresh-btn:hover:not(:disabled) {
	background: rgba(0, 0, 0, 0.06);
}

.balance-refresh-btn:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}

@keyframes balance-spin {
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
	}
}

.balance-refresh-btn--spinning {
	animation: balance-spin 0.7s linear infinite;
}

/* ================================================================
   移动端覆盖（仅 max-width 媒体查询内需调整的尺寸）
================================================================ */
@media (max-width: 767px) {
	.pc-img {
		width: 1.6rem !important;
		height: 1.6rem !important;
	}

	.pc-tag {
		font-size: 0.18rem;
		padding: 0.05rem 0.2rem;
	}

	.pc-period {
		font-size: 0.18rem;
	}

	.pc-name p {
		font-size: 0.22rem !important;
	}

	.item_Options .position .points_box li.pc-item .pc-btn {
		height: 0.72rem !important;
		font-size: 0.28rem !important;
	}

	.pc-coin {
		width: 0.32rem !important;
		height: 0.32rem !important;
	}
}
</style>